import { graphql } from "@opensea/graphql"

export const constructOffer_itemFragment = graphql(`
  fragment constructOffer_item on Item {
    id
    imageUrl
    tokenId
    contractAddress
    chain {
      offerCurrency {
        address
      }
      identifier
    }
  }
`)
